// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  toolbarText: {
    color: theme.palette.lightGrey,
    textTransform: 'none',
    // On a phone a long email would push the menu off the screen: it shortens, and the menu stays where it is
    [theme.breakpoints.down('sm')]: {
      maxWidth: theme.spacing(10),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  fontWeight: {
    fontWeight: 300,
  },
  cad: {
    fontWeight: 300,
    color: theme.palette.primary.main,
  },
  menuList: {
    minWidth: '150px',
  },
});

export default styles;
